import { render, staticRenderFns } from "./CatalogModal.vue?vue&type=template&id=3ba38aa8&"
import script from "./CatalogModal.vue?vue&type=script&lang=js&"
export * from "./CatalogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports